import React, {
  CSSProperties,
  ReactElement,
  useEffect,
  useState,
  Fragment,
} from 'react';
import Lottie from 'react-lottie';
import {useHistory} from 'react-router-dom';
import {
  setAppBarTitle,
  setBackNavAction,
  setBackNavEnabled,
} from '../../../redux/globalSlice';
import ReactTooltip from 'react-tooltip';
import ErrorToast from '../../../components/notifications/ErrorToast';
import Tool_Tip_Find_Missing from '../../../assets/json/Tool_Tip_Find_Missing.json';
import {
  MissingSizeData,
  error,
  loading,
  missingSizeApiCall,
  productIsLoading,
  productsearchError,
  productSearchApiCall,
  productSizeData,
  arrangeMissingSizeData,
  missingSizeOrderedInfo,
  resetState,
} from '../../../redux/missingSizeApiSlice';
import cogoToast from 'cogo-toast';
import {useAppDispatch, useAppSelector} from '../../../redux/hooks';
import BarcodeScan from '../../storescan/BarcodeScanner';
import StoreCodeMessage from '../../storescan/StoreCodeMessage';
import rightArrow from '../../../assets/images/right_arrow_btn.svg';
import infoIcon from '../../../assets/images/infoIcon.svg';

import useWindowDimensions from '../../../core/utils/window.utils';
import {
  getAccessToken,
  getColor,
  getSize,
} from '../../../core/localstorage-data';
import {BackButtonAction} from '../../../core/utils/string.util';
import {findMissingSize, setPageName} from '../../../lib/tagmanager';
import {pageName} from '../../../lib/constants';

const MissingSizeBarcode = (): ReactElement => {
  const navigate = useHistory();
  const [canScan, setCanScan] = useState(true);
  const misingSizeApiData = useAppSelector(MissingSizeData);
  const missingSizeHasError = useAppSelector(error);
  const missingSizeIsLoading = useAppSelector(loading);
  const productSearchData = useAppSelector(productSizeData);
  const productSearchHasError = useAppSelector(productsearchError);
  const productHasLoading = useAppSelector(productIsLoading);
  const accessToken = getAccessToken();
  const dispatch = useAppDispatch();
  const [checkBarcodeScan, setCheckBarcodeScan] = useState(false);
  const [enableBarcodeInput, setEnableBarcodeInput] = useState(false);
  const [enteBarcode, setEnterbarcode] = useState('');

  const missingSizeDetail = useAppSelector(missingSizeOrderedInfo);
  const infoTooltip = {
    loop: true,
    autoplay: true,
    animationData: Tool_Tip_Find_Missing,
    rendererSettings: {
      // preserveAspectRatio: "xMidYMid slice"
    },
  };
  //need to check last
  const productColor = getColor();
  const productSize = getSize();
  useEffect(() => {
    setPageName(pageName.missingsize);
    if (productColor != null) {
      localStorage.removeItem('color');
    }
    if (productSize != null) {
      localStorage.removeItem('size');
    }

    if (missingSizeDetail != undefined) {
      dispatch(resetState());
    }
  }, []);

  useEffect(() => {
    if (checkBarcodeScan === true) {
      const parameters = {
        payload: {
          eanNumber: enteBarcode,
        },

        accessToken: accessToken,
      };

      dispatch(productSearchApiCall(parameters));
    }
  }, [checkBarcodeScan]);

  useEffect(() => {
    dispatch(setAppBarTitle('Find missing size'));
    dispatch(setBackNavEnabled(true));
    dispatch(setBackNavAction(BackButtonAction.TO_HOME));

    return () => {
      dispatch(setAppBarTitle(''));
      dispatch(setBackNavEnabled(false));
    };
  }, [setAppBarTitle]);

  useEffect(() => {
    if (missingSizeDetail != undefined) {
      if (
        missingSizeDetail.productSizeStatusCheck == true &&
        enteBarcode != ''
      ) {
        ////add navigation here for select a size
        //   barcode(enteBarcode);
        navigate.push('selectsize');
        return;
      }
      if (missingSizeDetail.productCheckStatus == false && enteBarcode != '') {
        cogoToast.error(
          <ErrorToast title="Error" description="Product not found" />,
          {
            hideAfter: 2,
            renderIcon: () => {
              return null;
            },
          },
        );
        setTimeout(() => {
          setCanScan(true);
          setCheckBarcodeScan(false);
        }, 2000);
        dispatch(resetState());
        setEnterbarcode(' ');
        return;
      }
      if (missingSizeDetail.productCheckStatus == true && enteBarcode != '') {
        //add navigation here for select a size
        //  barcode(enteBarcode);

        navigate.push('selectsize');
      }
    }
  }, [missingSizeDetail]);

  useEffect(() => {
    if (missingSizeHasError != '' && missingSizeIsLoading == false) {
      cogoToast.error(
        <ErrorToast title="Error" description="Product not available" />,
        {
          hideAfter: 2,
          renderIcon: () => {
            return null;
          },
        },
      );

      setTimeout(() => {
        setCanScan(true);

        setCheckBarcodeScan(false);
      }, 2000);
      setEnterbarcode(' ');
      dispatch(resetState());
      return;
    }
    if (misingSizeApiData.name != '') {
      findMissingSize(productSearchData.itemCode,productSearchData.size,productSearchData.color,misingSizeApiData.price.value,misingSizeApiData.name)
      dispatch(arrangeMissingSizeData());
    }
  }, [misingSizeApiData, missingSizeHasError, missingSizeIsLoading]);
  useEffect(() => {
    if (
      productSearchHasError != '' &&
      productHasLoading == false &&
      enteBarcode != ''
    ) {
      cogoToast.error(
        <ErrorToast title="Error" description="Product not available" />,
        {
          hideAfter: 2,
          renderIcon: () => {
            return null;
          },
        },
      );

      dispatch(resetState());

      setEnterbarcode(' ');

      setTimeout(() => {
        setCanScan(true);

        setCheckBarcodeScan(false);
      }, 2000);
      return;
    }

    if (
      productSearchData.message != '' &&
      productHasLoading == false &&
      enteBarcode != ''
    ) {
      if (productSearchData.resultCode == '0') {
        dispatch(resetState());
        setEnterbarcode(' ');
        cogoToast.error(
          <ErrorToast
            title="Error"
            description="Something went wrong, Please try again."
          />,
          {
            hideAfter: 2,
            renderIcon: () => {
              return null;
            },
          },
        );
        setTimeout(() => {
          setCanScan(true);

          setCheckBarcodeScan(false);
        }, 2000);

        return;
      }
      if (productSearchData.resultCode == '6' && enteBarcode != '') {
        dispatch(resetState());
        setEnterbarcode(' ');

        cogoToast.error(
          <ErrorToast
            title="Invalid barcode"
            description="You are scanning an invalid barcode kindly check and scan again"
          />,
          {
            hideAfter: 2,
            renderIcon: () => {
              return null;
            },
          },
        );
        setTimeout(() => {
          setCanScan(true);

          setCheckBarcodeScan(false);
        }, 2000);

        return;
      }
      if (productSearchData.resultCode == '7' && enteBarcode != '') {
        dispatch(resetState());
        setEnterbarcode(' ');
        cogoToast.error(
          <ErrorToast title="Error" description="Item not found" />,
          {
            hideAfter: 2,
            renderIcon: () => {
              return null;
            },
          },
        );
        setTimeout(() => {
          setCanScan(true);

          setCheckBarcodeScan(false);
        }, 2000);

        return;
      }
      const baseProduct = productSearchData.base_product.split('-');
      const parameters = {
        payload: {
          itemCode: productSearchData.itemCode,
        },

        accessToken: accessToken,
      };
      dispatch(missingSizeApiCall(parameters));
    }
  }, [productSearchData, productSearchHasError, productHasLoading]);

  const unableScanLinkClick = () => {
    setEnableBarcodeInput(true);
  };

  const buttonHandler = (event: React.SyntheticEvent) => {
    event.preventDefault();
    const parameters = {
      payload: {
        eanNumber: enteBarcode,
      },

      accessToken: accessToken,
    };

    dispatch(productSearchApiCall(parameters));

    // barcode(enteBarcode);
  };
  const handleScan = (enterData: string) => {
    setEnterbarcode(enterData);
    setCheckBarcodeScan(true);
    setCanScan(false);
    //setEnterbarcode(scanBarcode);
  };
  const handleInputChange = (e: {
    target: {value: React.SetStateAction<string>};
  }) => {
    setEnterbarcode(e.target.value);
  };

  const {width} = useWindowDimensions();

  const cameraViewHeight = width - 32 * 2;
  const cameraViewEdgeBoxHeight = cameraViewHeight - (2 * cameraViewHeight) / 3;
  const boxStyles: CSSProperties = {
    height: `${cameraViewEdgeBoxHeight}px`,
    width: `${cameraViewEdgeBoxHeight}px`,
    borderColor: '#d83f38',
  };
  return (
    <Fragment>
      <div className="text-center bg-blue_three child-container relative p-4">
        <div className="absolute barcode-overlay-content bottom-0 flex flex-col left-0 right-0 top-0 z-10">
          <div className="flex-grow bg-black_two  ">
            <StoreCodeMessage
              title1={'Scan Product Barcode'}
              title2={'to find missing size'}
            />
          </div>

          <div className="scanner-container">
            <div className="corners">
              <div className="tops lefts">&nbsp;</div>
              <div className="tops rights">&nbsp;</div>
              <div className="bottoms rights">&nbsp;</div>
              <div className="bottoms lefts">&nbsp;</div>
              <BarcodeScan onScan={handleScan} canScan={canScan} />
            </div>
          </div>
          <div
            className="w-full border-1 bg-black_two  text-opacity-50    mt-4"
            style={{color: 'rgb(26, 26, 26,0.5)'}}></div>
          <div className="flex-grow bg-blue_two">
            {enableBarcodeInput ? (
              <div className=" px-12">
                <div className=" mb-4 mt-4 mx-auto">
                  <div>
                    <span className="text-small leading-18 text-center font-roboto text-black_zero">
                      Unable to scan barcode
                    </span>
                  </div>
                </div>
                <form onSubmit={buttonHandler}>
                  <div className="flex items-center mb-6 ">
                    <div className=" flex flex-col h-50 rounded-lg bg-blue_four w-full">
                      <div className="flex">
                        <div className="z-50 -mt-2 -ml-1">
                          <div data-tip data-for="registerTip">
                            <img
                              className="h-6 bg-white rounded-full"
                              src={infoIcon}
                            />
                          </div>
                          <div className="w-20">
                            <ReactTooltip
                              id="registerTip"
                              place="top"
                              effect="solid"
                              event="click"
                              backgroundColor="white"
                              clickable={true}
                              textColor="black"
                              className="-left-20 top-48 w-64 h-52">
                              <Lottie options={infoTooltip} />
                            </ReactTooltip>
                          </div>
                        </div>

                        <div className="-ml-14">
                          <span className="font-bold text-xs font-roboto">
                            Product barcode
                          </span>
                        </div>
                      </div>
                      <input
                        type="number"
                        onKeyDown={e =>
                          (e.keyCode === 69 ||
                            e.keyCode === 190 ||
                            e.key == '-') &&
                          e.preventDefault()
                        }
                        min="0"
                        className="w-10/12 bg-blue_four focus:outline-none font-roboto ml-4  "
                        placeholder="Enter product barcode"
                        value={enteBarcode}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="">
                      <button
                        onClick={buttonHandler}
                        className="w-12 h-50 focus:outline-none font-bold normal primary arrow rounded-r-lg text-white w-12 flex items-center justify-center"
                        disabled={
                          enteBarcode.length < 8 || enteBarcode.length > 17
                        }>
                        <img src={rightArrow} alt="Phone number" />
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            ) : (
              <div className="mt-11">
                <a
                  className=" text-red_zero font-bold  font-roboto"
                  onClick={unableScanLinkClick}>
                  Unable to scan ?
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default MissingSizeBarcode;
